const radios = document.querySelectorAll('input[name="controller"]');
const claimButton = document.getElementById("claimButton");
const extraInputs = document.getElementById("extraInputs");
const extraFields = document.querySelectorAll(".extra-field");
const warningMessage = document.getElementById("warningMessage");
const orderGroup = document.getElementById("orderGroup");
const serialNumberInput = document.getElementById("input-serial-number");
const customDrawerIn = document.querySelector("custom-cart-drawer");
let unique_atc = document.querySelector("#unique_atc");
const searchInput = document.querySelector(".vehicle-search-bar input");
const vehicleOptionsList = document.querySelector(".vehicle-options-list");
const vehicleSelectorNav = document.querySelector(".vehicle-selector-nav");
const vehicleSelector = document.querySelector("#vehicleSelector");
const navItem = document.getElementById("navItem");
const progressFill = document.querySelector(".vehicle-progress-fill");
const progressText = document.querySelector(".vehicle-progress-text");
let selectedPC = "";
let isLoading = false;


let makeModel = [];
let globalVariantTitles = [];

let selections = {
  make: null,
  model: null,
  year: null,
  engine: null
};

const stepOrder = ["make", "model", "year", "engine"];

const updateStepProgress = () => {
  const completedStepCount = stepOrder.filter(step => selections[step] !== null).length;
  const percent = (completedStepCount / stepOrder.length) * 100;

  // if (progressFill) progressFill.style.width = `${percent}%`;
  if (progressText) {
    const currentStep = Math.min(completedStepCount + 1, stepOrder.length);
    progressText.textContent = `Step ${currentStep} of ${stepOrder.length}`;
  }
};

const canEnableClaimButton = () => {
  const allSelected = selections.make && selections.model && selections.year && selections.engine;
  const isPedalCommander = [...radios].some(r => r.checked && r.value.toLowerCase().includes("pedal commander".toLowerCase()));
  const serialValue = serialNumberInput.value.trim();
  const serialValid = serialValue.length > 4;

  if (isPedalCommander) {
    claimButton.disabled = !(allSelected && serialValid);
  } else {
    claimButton.disabled = !allSelected;
  }
};

const updateDataSelection = () => {
  const isPedalCommander = [...radios].some(r => r.checked && r.value.toLowerCase().includes("pedal commander".toLowerCase()));
  const serialValue = serialNumberInput.value.trim();
  const hasValidSerial = serialValue.length > 4;

  let baseSelection = `${selectedPC} / ${selections.model} / ${selections.year} / ${selections.engine}`;

  if (isPedalCommander) {
    baseSelection += ` / Pedal Commander®`;
    if (hasValidSerial) {
      baseSelection += ` / ( serial number: ${serialValue} )`;
    }
  }else{
    baseSelection += ` / Other TRC`;
  }

  unique_atc.setAttribute("data-selection", baseSelection);
};


radios.forEach(radio => {
  radio.addEventListener("click", () => {
    vehicleSelector.style.display = "block";

    selections = {
      make: null,
      model: null,
      year: null,
      engine: null
    };

    claimButton.disabled = true;
    unique_atc.removeAttribute("data-selection");
    unique_atc.dataset.atc = radio.id;
    navItem.innerHTML = "";
    vehicleOptionsList.replaceChildren();
    renderMakes();
    updateStepProgress();

    if (radio.value.includes("Pedal Commander")) {
      orderGroup.style.display = "grid";
    } else {
      orderGroup.style.display = "none";
      serialNumberInput.value = "";
    }

    canEnableClaimButton();
  });
});

serialNumberInput.addEventListener("input", () => {  
  let serialNumberHint = document.getElementById("serial-number-hint");

  if (serialNumberInput.value.length > 6) {
    serialNumberInput.value = serialNumberInput.value.slice(0, 6); 
    serialNumberHint.style.display = "block"; 
    setTimeout(() => {
      serialNumberHint.style.display = "none";
    }, 3000)
  } else {
    serialNumberHint.style.display = "none"; 
  }
  
  canEnableClaimButton();
  updateDataSelection();
});


function loadingHandle(button) {
  let loadingSpinner = button.querySelector(".loading__spinner");
  let atcText = button.querySelector("span");

  atcText.classList.add("hidden");
  loadingSpinner.classList.remove("hidden");

  const observer = new MutationObserver(() => {
    if (customDrawerIn.style.visibility === 'visible') {
      loadingSpinner.classList.add("hidden");
      atcText.classList.remove("hidden");
      observer.disconnect();
    }
  });

  observer.observe(customDrawerIn, {
    attributes: true,
    attributeFilter: ["style"],
  });
}

claimButton.addEventListener("click", () => {
  unique_atc.click();
  loadingHandle(claimButton);
});

const fetchData = async (url) => {
  try {
    const response = await fetch(url, { mode: "cors" });
    return await response.json();
  } catch (error) {
    console.error("Fetch Error:", error);
  }
};

const appendLooxRatingSpans = () => {
  const modelItems = document.querySelectorAll(".vehicle-options-item");
  modelItems.forEach((li) => {
    const match = window.collectionProductList?.find(
      (p) => p.model.toLowerCase() === li.textContent.toLowerCase()
    );

    if (match) {
      const ratingSpan = document.createElement("span");
      ratingSpan.className = "loox-rating";
      ratingSpan.setAttribute("data-id", match.id);
      ratingSpan.setAttribute("data-rating", match.rating);
      ratingSpan.setAttribute("data-raters", match.reviews);
      li.appendChild(ratingSpan);
    }
  });
};


const resetFromStep = (step) => {
  const startIndex = stepOrder.indexOf(step);
  const navItems = navItem.querySelectorAll("li");

  navItems.forEach((li, index) => {
    if (index >= startIndex) li.remove();
  });

  for (let i = startIndex; i < stepOrder.length; i++) {
    selections[stepOrder[i]] = null;
  }

  claimButton.disabled = true;
  unique_atc.removeAttribute("data-selection");

  if (step === "make") {
    renderMakes();
  } else if (step === "model" && selections.make) {
      const makeObj = makeModel.find((m) => m.make === selections.make);
      renderList(makeObj.models.map((m) => ({ text: m })), handleModelSelect);
      appendLooxRatingSpans();
  } else if (step === "year" && selections.model) {
    handleModelSelect({ text: selections.model }, true);
  } else if (step === "engine" && selections.year) {
    handleYearSelect(selections.year, globalVariantTitles, true);
  }

  vehicleSelector.style.display = "block";
  updateStepProgress();
};




// const renderList = (items, clickHandler, attrName = null) => {
//   vehicleOptionsList.style.pointerEvents = "none";
//   setTimeout(() => {
//     vehicleOptionsList.style.pointerEvents = "auto";
//   }, 1000);
//   vehicleOptionsList.replaceChildren();
//   items.forEach((item) => {
//     const li = document.createElement("li");
//     li.className = "vehicle-options-item";
//     li.textContent = item.text;
//     if (attrName && item[attrName]) {
//       console.log("aaaaaaaaaaa")
//       li.dataset[attrName] = item[attrName];
//     }
//     li.addEventListener("click", () => clickHandler(item));
//     vehicleOptionsList.appendChild(li);
//   });
// };

const renderList = (items, clickHandler, attrName = null) => {
  isLoading = true;
  vehicleOptionsList.classList.add("is-loading"); 
  vehicleOptionsList.replaceChildren();

  items.forEach((item) => {
    const li = document.createElement("li");
    li.className = "vehicle-options-item";
    li.textContent = item.text;
    if (attrName && item[attrName]) {
      li.dataset[attrName] = item[attrName];
    }
    li.addEventListener("click", () => {
      if (!isLoading) clickHandler(item); 
    });
    vehicleOptionsList.appendChild(li);
  });


  requestAnimationFrame(() => {
    isLoading = false;
    vehicleOptionsList.classList.remove("is-loading");
  });
};

const addToNav = (step, text) => {
  const labelMap = {
    make: "Make",
    model: "Model",
    year: "Year",
    engine: "Engine"
  };

  if (step === "model" && selections.make) {
    const makeLower = selections.make.toLowerCase();
    const textLower = text.toLowerCase();
    if (textLower.startsWith(makeLower)) {
      text = text.slice(selections.make.length).trim();
    }
  }

  const li = document.createElement("li");
  li.innerHTML = `<strong>${labelMap[step]}:</strong> ${text}`;
  li.dataset.step = step;
  li.style.cursor = "pointer";
  li.addEventListener("click", () => resetFromStep(step));
  navItem.appendChild(li);
};

const handleMakeSelect = (item) => {
  selections.make = item.make;
  addToNav("make", item.make);
  const models = item.models.map((m) => ({ text: m }));
  renderList(models, handleModelSelect);

  appendLooxRatingSpans(); 

  vehicleSelectorNav.style.display = "block";
  updateStepProgress();
};

const handleModelSelect = async (item, isBacktrack = false) => {
  selections.model = item.text;
  if (!isBacktrack) addToNav("model", item.text);
  const slug = item.text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
  const url = `/products/${slug}.js`;
  const data = await fetchData(url);
  if (!data || !data.variants) return;
  globalVariantTitles = data.variants.map((v) => v.title.split("/"))
  const uniqueYears = [...new Set(globalVariantTitles.map((v) => v[3].trim()))]; // protect duplicate like dodge ram variants
  const yearItems = uniqueYears.map((y) => ({ text: y }));
  renderList(yearItems, (item) => handleYearSelect(item.text, globalVariantTitles));
  updateStepProgress();
};

const handleYearSelect = (year, variantTitles, isBacktrack = false) => {
  selections.year = year;
  if (!isBacktrack) addToNav("year", year);
  const matchingVariants = variantTitles.filter((v) => v[3].trim() === year);
  selectedPC = matchingVariants[0][0].trim();
  
  const engineOptions = [];
  matchingVariants.forEach((v) => {
    const engines = v[4].trim().split("-").map((e) => e.trim());
    engines.forEach((engine) => {
      if (!engineOptions.includes(engine)) {
        engineOptions.push(engine);
      }
    });
  });
  const engineItems = engineOptions.map((e) => ({
    text: e.replace(/[()]/g, "")
  }));

  if (engineItems.length === 1) {
    handleEngineSelect(engineItems[0]);
    return;
  }

  renderList(engineItems, handleEngineSelect, "engine");
  updateStepProgress();
};

const handleEngineSelect = (item) => {
  selections.engine = item.text;
  addToNav("engine", item.text);
  updateDataSelection()

  vehicleOptionsList.replaceChildren();
  vehicleSelector.style.display = "none";
  updateStepProgress();
  canEnableClaimButton();
};

const renderMakes = () => {
  const makeItems = makeModel.map((makeObj) => ({
    text: makeObj.make, // multi usage all logic
    make: makeObj.make,
    models: makeObj.models
  }));
  renderList(makeItems, handleMakeSelect);
};

document.addEventListener("DOMContentLoaded", async () => {
  const data = await fetchData("//pedalcommander.com/cdn/shop/t/265/assets/makeModel.json?v=128090689508164248651792086380");
  if (data && data.createdMakeModel) {
    makeModel = data.createdMakeModel;
    renderMakes();
  }
});
